import { render, staticRenderFns } from "./shellTeacher.vue?vue&type=template&id=a977d90c&comments=true&"
import script from "./shellTeacher.vue?vue&type=script&lang=js&"
export * from "./shellTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/syncScreen/shellTeacher.vue"
export default component.exports